import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/** Present to assistive tech, invisible on screen: the standard clip pattern, inline like the rest. */
const VISUALLY_HIDDEN = {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: 0,
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    whiteSpace: "nowrap",
    border: 0,
};
/** The token pair (and optional edge) each tone resolves to. */
export const PILL_TONES = {
    attention: {
        fg: "var(--feedback-warning)",
        bg: "var(--feedback-warning-bg)",
        edge: "var(--feedback-warning-border)",
    },
    waiting: { fg: "var(--status-waiting)", bg: "var(--status-waiting-bg)", edge: "transparent" },
    progress: {
        fg: "var(--status-in-progress)",
        bg: "var(--status-in-progress-bg)",
        edge: "transparent",
    },
    good: { fg: "var(--status-approved)", bg: "var(--status-approved-bg)", edge: "transparent" },
    bad: { fg: "var(--status-rejected)", bg: "var(--status-rejected-bg)", edge: "transparent" },
    muted: { fg: "var(--status-cancelled)", bg: "var(--status-cancelled-bg)", edge: "transparent" },
    neutral: { fg: "var(--ard-text-2)", bg: "var(--ard-surface-2)", edge: "transparent" },
};
export function Pill({ tone = "neutral", size = "default", children, className, title, fullLabel, }) {
    const spec = PILL_TONES[tone];
    const cls = ["pill", `pill--${tone}`, size === "lg" ? "pill--lg" : "", className ?? ""]
        .filter(Boolean)
        .join(" ");
    return (_jsx("span", { className: cls, "data-tone": tone, title: title ?? fullLabel, style: {
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            borderRadius: "var(--radius-full)",
            padding: size === "lg" ? "6px 14px" : "3px 10px",
            border: `1px solid ${spec.edge}`,
            background: spec.bg,
            color: spec.fg,
            font: `500 ${size === "lg" ? "14px" : "13px"}/1.3 var(--font-ui)`,
            whiteSpace: "nowrap",
        }, children: fullLabel === undefined ? (children) : (_jsxs(_Fragment, { children: [_jsx("span", { "aria-hidden": "true", children: children }), _jsx("span", { style: VISUALLY_HIDDEN, children: fullLabel })] })) }));
}
export default Pill;
//# sourceMappingURL=Pill.js.map